import { z } from 'zod';

export const LibraryMetaUniquenessSchema = z.enum(['generic', 'variant', 'unique']);
export type LibraryMetaUniqueness = z.infer<typeof LibraryMetaUniquenessSchema>;

export const LibraryMetaSourceSchema = z.enum(['builtin', 'ai_generated', 'player_derived']);
export type LibraryMetaSource = z.infer<typeof LibraryMetaSourceSchema>;

export const LibraryMetaStatusSchema = z.enum(['draft', 'candidate', 'promoted', 'disabled']);
export type LibraryMetaStatus = z.infer<typeof LibraryMetaStatusSchema>;

export const LibraryMetaSchema = z.object({
  reusable: z.boolean().default(true),
  uniqueness: LibraryMetaUniquenessSchema.default('generic'),
  source: LibraryMetaSourceSchema.default('builtin'),
  status: LibraryMetaStatusSchema.default('promoted'),
  exposeToAi: z.boolean().default(true),
  tags: z.array(z.string()).default([]),
});
export type LibraryMeta = z.infer<typeof LibraryMetaSchema>;
